import React, { useCallback, useEffect } from 'react';
import { Player, PlayersPreset, playersPresetsApi } from '../../api';

async function loadPresets(
  setPresets: (presets: PlayersPreset[]) => void,
  setLastUpdatedAt: (updatedAt: number) => void
) {
  const presets = await playersPresetsApi.list();
  setPresets(presets);
  setLastUpdatedAt(Date.now());
}

export function usePlayersPresets() {
  const [presets, setPresets] = React.useState<PlayersPreset[]>([]);
  const [lastUpdatedAt, setLastUpdatedAt] = React.useState(Date.now());
  const didPlayersLoadingRef = React.useRef(false);

  const removePreset = useCallback(
    async (reset: PlayersPreset) => {
      await playersPresetsApi.remove(reset.id);
      await loadPresets(setPresets, setLastUpdatedAt);
    },

    [setPresets, setLastUpdatedAt]
  );

  const addPreset = useCallback(
    async (players: Player[]) => {
      await playersPresetsApi.add(players);
      await loadPresets(setPresets, setLastUpdatedAt);
    },
    [setPresets, setLastUpdatedAt]
  );

  useEffect(() => {
    if (didPlayersLoadingRef.current) {
      return;
    }
    didPlayersLoadingRef.current = true;
    loadPresets(setPresets, setLastUpdatedAt);
  }, []);

  return {
    lastUpdatedAt,
    presets,
    removePreset,
    addPreset,
  };
}
